window.addEventListener("load", function () {
    waitForElement("div#oke-loyalty-earn .c-customisableActionCard-titleArea-subtitle.u-textStyleEmbedded--body", (targetNode) => {
        initObserver(targetNode);
        removeCreditText(); // run immediately
    });
});

function waitForElement(selector, callback, timeout = 10000) {
    const interval = 300;
    let elapsed = 0;

    const timer = setInterval(() => {
        const el = document.querySelector(selector);

        if (el) {
            clearInterval(timer);
            callback(el);
        }

        elapsed += interval;
        if (elapsed >= timeout) {
            clearInterval(timer);
            console.warn(selector + " not found within timeout");
        }
    }, interval);
}

function initObserver(targetNode) {
    const observer = new MutationObserver(() => {
        removeCreditText();
    });

    observer.observe(targetNode, {
        childList: true,
        subtree: true
    });
}

function removeCreditText() {
    const targets = document.querySelectorAll(
        "div#oke-loyalty-earn .c-customisableActionCard-titleArea-subtitle.u-textStyleEmbedded--body"
    );

    targets.forEach((target) => {
        if (target.textContent.includes("Store Credit")) {
            target.textContent = target.textContent.replace("Store Credit", "");
        }
    });
}

window.addEventListener("load", function () {
    const modalSelector =
        "div.c-embeddedModal--customisable.c-embeddedModal";

    const textSelector =
        ".c-achievementDetails-details > .u-textStyle--body";

    const modalObservers = new WeakMap();

    function updateTextElement(root) {
        // Update achievement detail text
        const targets = [];

        if (root.matches?.(textSelector)) {
            targets.push(root);
        }

        targets.push(...root.querySelectorAll(textSelector));

        targets.forEach((target) => {
            if (target.textContent.includes("achievement")) {
                target.textContent = target.textContent.replace(
                    /achievement/g,
                    "high five"
                );
            }
        });

        // Update the #view-achievement element
        const viewAchievement = [];

        if (root.matches?.("#view-achievement")) {
            viewAchievement.push(root);
        }

        viewAchievement.push(
            ...root.querySelectorAll("#view-achievement")
        );

        viewAchievement.forEach((target) => {
            if (target.textContent.trim() === "Achievement") {
                target.textContent = "High Fives";
            }
        });
    }

    function cleanupModal(modal) {
        const observer = modalObservers.get(modal);

        if (observer) {
            observer.disconnect();
            modalObservers.delete(modal);
        }
    }

    function processModal(modal) {
        if (modalObservers.has(modal)) return;

        updateTextElement(modal);

        const modalObserver = new MutationObserver(() => {
            updateTextElement(modal);
        });

        modalObservers.set(modal, modalObserver);

        modalObserver.observe(modal, {
            childList: true,
            subtree: true,
            characterData: true
        });
    }

    // Handle an existing modal
    document.querySelectorAll(modalSelector).forEach(processModal);

    // Watch for modal creation and removal
    const pageObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.removedNodes.forEach((node) => {
                if (node.nodeType !== Node.ELEMENT_NODE) return;

                if (node.matches(modalSelector)) {
                    cleanupModal(node);
                }

                node.querySelectorAll(modalSelector).forEach(cleanupModal);
            });

            mutation.addedNodes.forEach((node) => {
                if (node.nodeType !== Node.ELEMENT_NODE) return;

                if (node.matches(modalSelector)) {
                    processModal(node);
                }

                node.querySelectorAll(modalSelector).forEach(processModal);

                // Also handle #view-achievement if added separately
                updateTextElement(node);
            });
        });
    });

    pageObserver.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Handle #view-achievement if it already exists
    updateTextElement(document);
});